import axios from 'axios';
import { API_URL } from './constants';
import Decode from '../utils/v1.1/decodeJWT';
import { JWTPayload } from 'types/token';

const isExpired = (tokenData: JWTPayload | null): boolean => {
  const exp = tokenData?.exp;
  return typeof exp === 'number' && new Date(exp * 1000) < new Date();
};

/**
 * @deprecated Use lib/api.ts instead
 */
const instance = axios.create({
  baseURL: API_URL,
});

instance.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;
    if (err?.response?.data?.error?.is_refresh_invalid) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      window.location.assign('/');
    } else if (
      err?.response?.data?.error?.is_access_invalid === 'True' &&
      !originalConfig._retry
    ) {
      originalConfig._retry = true;
      try {
        if (isExpired(Decode())) {
          const rs = await instance.post('/v1.1/token/refresh/', {
            refresh: localStorage.getItem('refresh'),
            'tenant-id': localStorage.getItem('tenant'),
          });
          const { access } = rs.data;
          localStorage.setItem('token', access);
          originalConfig.headers.Authorization = `Bearer ${access}`;
        }
        return instance(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
    return Promise.reject(err);
  },
);
export default instance;
